module.exports = __webpack_public_path__ + "static/media/copyright_logo.5e8552c8.png";